import { CryptoType } from '@/hooks/useGetCrypto';
import { Stack } from '@mui/material';
import Image from 'next/image';
import { FC, useMemo } from 'react';
import Typography from '../Typography';
import useLiveCrypto, { sourceType } from '@/hooks/useLiveCrypto';
import Info from '../../../public/json/shitcoin/info.json';
import find from 'lodash/find';

type InfiniteListItemProps = {
  crypto: CryptoType;
};

const InfiniteListItem: FC<InfiniteListItemProps> = ({ crypto }) => {
  function getMultipleRandom(arr: any[], num: number) {
    const shuffled = [...arr].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, num);
  }
  const variants = {
    down: {
      bg: getMultipleRandom(
        ['/assets/shitcoin/down_fill.svg', '/assets/shitcoin/down_outline.svg'],
        1
      )[0],
      textColor: 'error.A100'
    },
    up: {
      bg: getMultipleRandom(
        ['/assets/shitcoin/up_fill.svg', '/assets/shitcoin/up_outline.svg'],
        1
      )[0],
      textColor: 'success.A100'
    },
    normal: {
      bg: getMultipleRandom(
        [
          '/assets/shitcoin/down_outline.svg',
          '/assets/shitcoin/up_outline.svg'
        ],
        1
      )[0],
      textColor: 'textColor.A20'
    }
  };
  const getVariant = (change: number) => {
    if (change < 0) return variants.down;
    if (change > 0) return variants.up;
    return variants.normal;
  };
  const itemSource: sourceType =
    (find(Info.list, cr => cr.base === crypto.base && cr.quote === crypto.quote)
      ?.source as sourceType) || 'otc';
  const itemSourceKey = itemSource === 'otc' ? 'midPrice' : 'price';

  const { message, isConnected } = useLiveCrypto({
    source: itemSource,
    symbol: crypto.symbol,
    connect: true,
    pingPong: false
  });

  const priceKey = itemSource === 'otc' ? 'midPrice' : 'price';
  const closePrice = crypto[itemSource]?.[itemSourceKey];

  const itemVariant = useMemo(
    () => getVariant(Number(crypto[itemSource]?.priceChange || 0)),
    []
  );
  return (
    <Stack
      width={{ xs: 231, lg: 272 }}
      height={{ xs: 96, lg: 104 }}
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      dir="rtl"
      pl={{ xs: 4, lg: 6 }}
      pr={{ xs: 4, lg: 8 }}
      position="relative"
    >
      <Stack
        gridArea="crypto"
        flexDirection="row"
        alignItems="center"
        gap={1.5}
        zIndex={2}
      >
        <Image
          priority
          src={crypto.logoUrl || ''}
          alt=""
          width={32}
          height={32}
          style={{ borderRadius: '50%' }}
        />

        <Stack gap={0} maxWidth={100}>
          <Typography
            sx={{ color: '#EAECEE' }}
            variant="body3"
            weight="bold"
            maxWidth={50}
            noWrap
          >
            {crypto.baseFa}
          </Typography>
          <Typography sx={{ color: '#878D9A' }} variant="body4" noWrap>
            {crypto.base}
          </Typography>
        </Stack>
      </Stack>
      <Stack alignItems="end" zIndex={2}>
        <Stack gap={1.5} flexDirection="row" alignItems="center">
          <Typography
            variant="body3"
            sx={{ color: '#E1E3E5' }}
            weight="bold"
            noWrap
            maxWidth={80}
            dir="ltr"
            textAlign="end"
          >
            {isConnected && !!message?.[priceKey]
              ? message[priceKey]
              : closePrice}
          </Typography>
          <Typography variant="body4" sx={{ color: '#E1E3E5' }}>
            تومان
          </Typography>
        </Stack>
        <Typography variant="body4" color={itemVariant.textColor} dir="ltr">
          (
          {isConnected && !!message?.priceChange
            ? message.priceChange
            : crypto[itemSource]?.priceChange}
          )
        </Typography>
      </Stack>
      <Image
        priority
        src={itemVariant.bg || ''}
        fill
        alt=""
        style={{ zIndex: 1 }}
      />
    </Stack>
  );
};

export default InfiniteListItem;
